import React, { FC, memo, useContext } from 'react'
import { SmartCaptcha } from '@yandex/smart-captcha'
import { getSmartCaptchaLanguage } from './utils/getSmartCaptchaLanguage'
import { LanguageContext } from '../../../../LanguageContext/LanguageContext'
import style from './Captcha.module.css'

type CaptchaProps = {
  onSuccess(): void
}

export const Captcha: FC<CaptchaProps> = memo(({ onSuccess }) => {
  const { language } = useContext(LanguageContext)

  return (
    <div className={style.conatiner}>
      <SmartCaptcha
        language={getSmartCaptchaLanguage(language)}
        sitekey="ysc1_RukuqoEjqOBUjftYOgQZ3KSAZBgoBXScfVT9fOJq0b302223"
        onSuccess={onSuccess}
      />
    </div>
  )
})

Captcha.displayName = 'Captcha'
